import { useEffect } from "react";
import { createPortal } from "react-dom";
import CustomButton from "../components/custom-button";
import Loader from "../components/loader";
import { useDeleteModel } from "../store/use-delete-model";

interface TDeleteModel {
  loading: boolean;
}

const DeleteModel = ({ loading = false }: TDeleteModel) => {
  const { onCloseDeletePopup, initialValues } = useDeleteModel();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !loading) onCloseDeletePopup();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [loading, onCloseDeletePopup]);

  return createPortal(
    <div
      className="z-[99999] w-screen h-screen fixed inset-0 bg-[color:var(--shadow-modal-scrim)] backdrop-blur-sm flex items-center justify-center animate-fade-in"
      onClick={() => !loading && onCloseDeletePopup()}
    >
      <div
        className="bg-surface border border-edge shadow-overlay w-[min(92vw,460px)] rounded-2xl p-7 animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-[19px] font-bold text-heading-color leading-snug">
          Are you sure you want to delete this chase?
        </h2>

        <p className="mt-2.5 text-[13px] font-medium text-text-secondary leading-relaxed">
          This permanently removes the chase and everything recorded against it.
          This can't be undone.
        </p>

        <div className="flex items-center justify-end gap-2.5 mt-7">
          <CustomButton
            disabled={loading}
            className="bg-surface border border-edge hover:border-edge-strong cursor-pointer rounded-xl h-10 px-5 font-semibold !text-[14px] text-heading-color transition-colors duration-200"
            onClick={onCloseDeletePopup}
          >
            Cancel
          </CustomButton>
          <CustomButton
            disabled={loading}
            className="bg-gradient-to-r from-red-500 to-red-600 shadow-[0_8px_20px_-8px_rgba(239,68,68,0.65)] hover:-translate-y-px cursor-pointer rounded-xl h-10 px-5 font-semibold !text-[14px] text-white transition-all duration-200"
            onClick={initialValues.onClick}
          >
            {loading ? <Loader /> : "Delete"}
          </CustomButton>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteModel;
